import { RootState } from 'state/store';

// Base selector to get the modal state
export const modalComponentSelector = (state: RootState) => state.modalComponentReducer;

export const modalComponentStepSelector = (state: RootState) => state.modalComponentReducer.modalStep;
